import { Component, Output, EventEmitter } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'upsc-dw-recipient',
  templateUrl: './dw-recipient.component.html',
  styleUrls: ['./dw-recipient.component.scss']
})
export class DwRecipientComponent {

  @Output() cpRecipient = new EventEmitter<any>();
  isCommerceGuard: boolean = false;

  constructor(userService: UserService) {
    this.isCommerceGuard = userService.isDDCommerceGuardUser();
  }

  continue() {
    this.cpRecipient.emit("continue");
  }

  cancel() {
    this.cpRecipient.emit("cancel");
  }

}
